
import { RegistrationFormValues } from '@/schemas/registrationSchema';

/**
 * Checks if a registration form submission has duplicate data with existing attendees
 * @param formData The form data to check
 * @returns An object with duplication status and message if duplicate found
 */
export const checkDuplicateRegistration = (formData: RegistrationFormValues): { 
  isDuplicate: boolean; 
  message: string | null;
  field: 'fullName' | 'email' | 'phone' | 'class' | null;
} => {
  // Load attendees from localStorage to check for duplicates
  const storedAttendees = localStorage.getItem('attendees');
  const attendees = storedAttendees ? JSON.parse(storedAttendees) : [];
  
  // Find attendees with exact match on ALL required fields (fullName, email, phone, class)
  const exactDuplicate = attendees.find(
    (attendee: any) => 
      attendee.name?.toLowerCase() === formData.fullName.toLowerCase() &&
      attendee.email?.toLowerCase() === formData.email.toLowerCase() &&
      attendee.phone === formData.phone &&
      attendee.class === formData.class
  );
  
  if (exactDuplicate) {
    return {
      isDuplicate: true,
      message: `Thông tin của "${formData.fullName}" đã được đăng ký trước đó`,
      field: 'fullName'
    };
  }

  // No duplicates found (only consider duplicate if ALL fields match)
  return {
    isDuplicate: false,
    message: null,
    field: null
  };
};
